export const environment = {
  production: false,
  hostname: 'localhost',
  accordUrl: 'https://accord.stg.crewdle.ai',
  adminConsoleUrl: 'https://admin.stg.crewdle.ai',
  authBaseUrl: 'https://auth.stg.crewdle.ai',
  firebase: {
    apiKey: 'AIzaSyDHDgmA574NVeMWV9SpW-q4QQMjkANuueg',
    authDomain: 'auth.stg.crewdle.ai',
    databaseURL: 'https://crewdle-sdk-stg-default-rtdb.firebaseio.com',
    projectId: 'crewdle-sdk-stg',
    storageBucket: 'crewdle-sdk-stg.firebasestorage.app',
    messagingSenderId: '519415702791',
    appId: '1:519415702791:web:5dd39042f881cfde3251a2',
    measurementId: 'G-65GE57FYE4',
  },
};
